/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: It-service
 * Page name: ItService Page
 * Page Description: This is the IT service page of the website of Ekathva Innovations, it consists of all the
 * brief IT service provided by the company.
 */

import React,{ Component } from 'react'

import { Link } from 'react-router-dom';
import MetaTags from "react-meta-tags";
import Aos from 'aos'
import { Card, Container, Media, Row, Col,Image, Button, Modal  } from 'react-bootstrap';
import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';
import Navbar from "components/Navbars/Navbar";
import LandingPageIT from 'components/Headers/LandingPageIT'
import Footer from 'components/Footers/Footer'

import { Formik, Form } from 'formik';
import { Input, Label } from 'reactstrap';
import Validation from '../Validation.js';
import ApiService from '../api/ApiService.js';

import 'assets/style/Style.css'
import successImage from 'assets/images/AllPage/list.png';
import failureImage from 'assets/images/AllPage/into.png';

//Bookmarks
import 'views/SuccessStoriesPage'
import {ReactComponent as Plus} from "assets/images/AllPage/Plus.svg"
//Icon
import {ReactComponent as IT1} from "assets/images/ItService/IT1.svg"
import {ReactComponent as IT2} from "assets/images/ItService/IT2.svg"
import {ReactComponent as IT3} from "assets/images/ItService/IT3.svg"
import {ReactComponent as IT4} from "assets/images/ItService/IT4.svg"
import {ReactComponent as IT5} from "assets/images/ItService/IT5.svg"
import {ReactComponent as IT6} from "assets/images/ItService/IT6.svg"
import {ReactComponent as IT7} from "assets/images/ItService/IT7.svg"

//Snapshots
import IBBANIs from "assets/images/Snapshots/IBBANIs.png"
import VTECHs from "assets/images/Snapshots/VTECHs.png"
import ROOTSGOODSs from "assets/images/Snapshots/ROOTSGOODSs.png"
import MONICAs from "assets/images/Snapshots/MONICAs.png"
import GFGCs from "assets/images/Snapshots/GFGCs.png"
import GLWCs from "assets/images/Snapshots/GLWCs.png"
import VAMLs from "assets/images/Snapshots/VAMLs.png"
import MORINGAs from "assets/images/Snapshots/MORINGAs.png"
import VISHWAs from "assets/images/Snapshots/VISHWAs.png"
import SUMUKHAs from "assets/images/Snapshots/SUMUKHAs.png"
import MALNADs from "assets/images/Snapshots/MALNADs.png"
import SCHOLARs from "assets/images/Snapshots/SCHOLARs.png"
import CLINICALs from "assets/images/Snapshots/CLINICALs.png"
import CSIs from "assets/images/Snapshots/CSIs.png"
import DSCs from "assets/images/Snapshots/DSCs.png"
import AMSTs from "assets/images/Snapshots/AMSTs.png"
import ISVMs from "assets/images/Snapshots/ISVMs.png"
import RGA from "assets/images/Snapshots/RGA.jpg"

import Technorings from "assets/images/Snapshots/TL.png"
import EILEARN from "assets/images/Snapshots/EILEARN.png"
//Technologies
import Test1 from "assets/images/ItService/Test1.jpg"
import Test2 from "assets/images/ItService/Test2.jpg"
import Test3 from "assets/images/ItService/Test3.jpg"
import Test4 from "assets/images/ItService/Test4.jpg"
//Mobile view
import TechM1 from "assets/images/ItService/TechM1.jpg"
import TechM2 from "assets/images/ItService/TechM2.jpg"
import TechM3 from "assets/images/ItService/TechM3.jpg"
import TechM4 from "assets/images/ItService/TechM4.jpg"



import ItTechnologies from "views/ItTechnologies"


const responsive = {
  superLargeDesktop: {

    breakpoint: { max: 4000, min: 3000 },
    items: 1
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

class ItServicePage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      modal_project: false,
      modal_success: false,
      modal_failure: false,
      name: "",
      projectTitle: "",
      emailAddress: "",
      contactNumber: "",
      organizationName: "",
      city: "",
      requirement: "",
              }

    this.onProjectSubmit = this.onProjectSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.toggle = this.toggle.bind(this);
  };


  componentDidMount() {
    // this is needed, because InfiniteCalendar forces window scroll
    window.scrollTo(0, 0);
  }

    toggle = modalType => () => {
      console.log("inside toggle");
      if (!modalType) { return this.setState({ modal: !this.state.modal }); }
      this.setState({ [`modal_${modalType}`]: !this.state[`modal_${modalType}`] });
    };

    handleChange(event) {
      const target = event.target;
      const name = target.name;
      let value = event.target.value
      this.setState({ [name]: value});
    }

    onKeyPressTextOnly(event) {
      if(event.charCode !== 32){ Validation.onKeyPressTextOnly(event); }
    }
    onKeyPressNumberOnly(event){
      if(event.charCode !== 32){ Validation.onKeyPressNumberOnly(event);  }
    }
    onKeyPressRetrisctSomeSC(event){
    if(event.charCode !== 32){ Validation.onKeyPressRetrisctSomeSC(event);  }
  }

  camelCaseString(string){

    let words = string.trim().split(" ");

    let result = "";

    for(let i=0; i < words.length; i++){
      if(words[i] !== ""){
        result = result + " " +words[i][0].toUpperCase() + words[i].substring(1).toLowerCase();
      }
    }

    return result;

  }

  onProjectSubmit(values) {

    console.log(values);

      let fields = {
        name: this.camelCaseString(values.name),
        projectTitle: this.camelCaseString(values.projectTitle),
        emailAddress: values.emailAddress,
        contactNumber: values.contactNumber,
        organizationName: this.camelCaseString(values.organizationName),
        city: this.camelCaseString(values.city),
        requirement: values.requirement
      }


      ApiService.createProject(fields)
      .then((response) =>{
        this.setState({
          modal_project: !this.state.modal_project,
          modal_success: !this.state.modal_success,
          message: "We have received your Requirement! We will get back to you soon."
        })
      }).catch((error) =>{
        this.setState({
          modal_project: !this.state.modal_project,
          modal_failure: !this.state.modal_failure,
          message: "Something Went Wrong! Please Try Again"
        })
      })
    }

    render() {
      let {name, projectTitle, emailAddress, contactNumber, organizationName, city, requirement} = this.state
      return (

        <div>
            <MetaTags>
                <title>Website Development, Mobile App development, Enterprise Softwares in Shivamogga | Ekathva Innovations Pvt Ltd</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
            </MetaTags>

            <Navbar/>
            <LandingPageIT/>
            <br/>

            <div className='homepage_spacing' >
                <div >
                    <br/>
                    <Row>
                        <Col  md={5}>
                            <div className='it_listdisplay' >
                                <Row>
                                    <Col>
                                        <Media data-aos="fade-right">
                                            <IT1 className="align-self-start mr-3 svgcolor it_listlogosize"/>
                                            <Media.Body>
                                                <p>
                                                    <strong>Android / iOS App Development</strong>
                                                </p>
                                            </Media.Body>
                                        </Media>
                                        <br/>
                                        <Media data-aos="fade-right">
                                            <IT2 className="align-self-start mr-3 svgcolor it_listlogosize" />
                                            <Media.Body>
                                                <p>
                                                    <strong>
                                                    Web Application Development</strong>
                                                </p>
                                            </Media.Body>
                                        </Media>
                                        <br/>
                                        <Media data-aos="fade-right">
                                            <IT3 className="align-self-start mr-3 svgcolor it_listlogosize" />
                                            <Media.Body>
                                                <p>
                                                <strong>
                                                    Web Design and Development</strong>
                                                </p>
                                            </Media.Body>
                                        </Media>
                                        <br/>
                                        <Media data-aos="fade-right">
                                            <IT4 className="align-self-start mr-3 svgcolor it_listlogosize" />
                                            <Media.Body>
                                                <p>
                                                <strong>
                                                    Domain Registration and Hosting</strong>
                                                </p>
                                            </Media.Body>
                                        </Media>
                                        <br/>
                                        <Media data-aos="fade-right">
                                            <IT5 className="align-self-start mr-3 svgcolor it_listlogosize" />
                                            <Media.Body>
                                                <p >
                                                <strong>
                                                    Software Development</strong>
                                                </p>
                                            </Media.Body>
                                        </Media>
                                        <br/>
                                        <Media data-aos="fade-right">
                                            <IT6 className="align-self-start mr-3 svgcolor it_listlogosize" />
                                            <Media.Body>
                                                <p>
                                                <strong>
                                                    SEO and Digital Marketing</strong>
                                                </p>
                                            </Media.Body>
                                        </Media>
                                        <br/>
                                        <Media data-aos="fade-right">
                                            <IT7 className="align-self-start mr-3 svgcolor it_listlogosize" />
                                            <Media.Body>
                                                <p>
                                                <strong>
                                                    Logo and other Design Services</strong>
                                                </p>
                                            </Media.Body>
                                        </Media>
                                    </Col>
                                </Row>
                            </div>
                        </Col>

                        <Col data-aos="fade-left"  md={7}>
                            <p>
                                <strong>
                                    Ekathva Innovations offers a wide range of services in the area of application development
                                    and Information Technology.  We deliver services from poster designing to web designing with
                                    our expertise in the field of information technology and digitalizing the businesses through
                                    Website Design and Development, Android / iOS App Development, Customized/Enterprise software
                                    development, Domain Registration, and Hosting, Logo Design and other marketing designs.
                                </strong>
                            </p>
                            <p>
                                <strong>
                                    As of today, we have served more than 45+ satisfied clients through our Design and Development
                                    expertise. Our expertise has enabled us to create smart, responsive websites and applications
                                    for almost all various businesses out there in the market.
                                </strong>
                            </p>
                            <br/>

                            <div className='it_listdisplay1'>
                                <ul>
                                    <li><p className='aboutus_fontbold'>Android/ Ios App Development</p></li>
                                    <li><p className='aboutus_fontbold'>Website Applicaton Development</p></li>
                                    <li><p className='aboutus_fontbold'>Website Design and Development</p></li>
                                    <li><p className='aboutus_fontbold'>Domain Registration and Hosting</p></li>
                                    <li><p className='aboutus_fontbold'>Software Development</p></li>
                                    <li><p className='aboutus_fontbold'>SEO and Digital Marketing</p></li>
                                    <li><p className='aboutus_fontbold'>Logo and other Design Services</p></li>
                                </ul>
                            </div>

                            <br/><br/>
                            <h5>
                                <span className='aboutus_fontbold'>  Technologies </span>we work with <Link to="/Technologies">
                                <Plus class="rounded mx-auto homepage_plussize" />
                                </Link>
                                </h5>
                            <div  data-aos="zoom-in" className='it_techspacing'>

                                    <ItTechnologies />

                            </div>

                            <div className='it_techspacing1'>
                                <Link to='/technologies'>
                                    <Carousel
                                    autoPlay={true}
                                    responsive={responsive}
                                    infinite={true}
                                    autoPlaySpeed={2500}>
                                        <Row interval={900}>
                                            <div>
                                                <img src={'https://drive.google.com/uc?export=view&id=1z-f3yg6PeKb-f8u8tjUSNoZI4OIB-XbJ'} className='it_techimage'/>
                                            </div>
                                        </Row>
                                        <Row interval={900}>
                                            <div>
                                                <img src={'https://drive.google.com/uc?export=view&id=18AWXO50HJchoDMQ4HeyS0V_WAX5uu0Bx'} className='it_techimage'/>
                                            </div>
                                        </Row>
                                        <Row interval={900}>
                                            <div>
                                                <img src={'https://drive.google.com/uc?export=view&id=1SkhUE_50z5kFypr8uIoDDXdWwqAGZ99W'} className='it_techimage'/>
                                            </div>
                                        </Row>
                                        <Row interval={900}>
                                            <div>
                                                <img src={'https://drive.google.com/uc?export=view&id=1EM44hYkQKdZ21DaiuFQtADhFGK6uB0Pv'} className='it_techimage'/>
                                            </div>
                                        </Row>
                                    </Carousel>
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </div>
                <hr/>
            </div>
            <br/>

            <div className='aboutus_mainspace'>
                <Row>
                    <Col>
                        <Card>
                            <div className='embedded_projectspacing'>
                                    <h4> <span className='aboutus_fontbold' >Let's Work</span> Together</h4>
                                <p>
                                    <strong>
                                        If you have an idea/requirement and you feel we can serve you, please let us know.
                                    </strong>
                                </p>
                                <div className='it_buttonalign' >


                                <Link onClick={this.toggle('project')} class="cta" style={{ textDecoration: 'none' }}>
                                <span>Start a Project</span>
                                <svg width="13px" height="10px" viewBox="0 0 13 10">
                                <path d="M1,5 L11,5"></path>
                                <polyline points="8 1 12 5 8 9"></polyline>
                                </svg>
                                </Link>
                                </div>
                                <Modal show={this.state.modal_project} backdrop='static' size="lg"
                                aria-labelledby="contained-modal-title-vcenter"
                                centered>
                                <Modal.Header closeButton onClick={this.toggle('project')}>
                                <Modal.Title>
                                Start a Project
                                </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                <Formik
                                onSubmit={this.onProjectSubmit}
                                initialValues={{name, projectTitle, emailAddress, contactNumber, organizationName, city, requirement}}
                                validateOnChange={false}
                                validateOnBlur={false}
                                enableReinitialize={true}
                                onChange={this.handleChange}>

                                <Form>

                                <Row>
                                <Col md={2}>
                                <label>Project Title<span className="register_page_marker">*</span></label>
                                </Col>
                                <Col md={4}>
                                <Input  className="capitalize"
                                name="projectTitle" type="text"
                                onKeyPress={event => {this.onKeyPressTextOnly(event)}}
                                onChange={this.handleChange}
                                placeholder="Enter Project Title"
                                minLength="2" maxLength="200" required />
                                </Col>
                                <Col md={2}>
                                <label>Name<span className="register_page_marker">*</span></label>
                                </Col>
                                <Col md={4}>
                                <Input  className="capitalize"
                                name="name" type="text"
                                onKeyPress={event => {this.onKeyPressTextOnly(event)}}
                                onChange={this.handleChange}
                                placeholder="Enter Your Name"
                                minLength="2" maxLength="200" required />
                                </Col>
                                </Row>
                                <br />
                                <Row>
                                <Col md={2}>
                                <label>Contact Number<span className="register_page_marker">*</span></label>
                                </Col>
                                <Col md={4} className="text-center">
                                <Input
                                name="contactNumber" type="text"
                                minLength="10" maxLength="10"
                                placeholder="Enter Your Contact Number"
                                onChange={this.handleChange}
                                onKeyPress={event => {this.onKeyPressNumberOnly(event)}}
                                required />
                                </Col>
                                <Col md={2} >
                                <label>Email Address<span className="register_page_marker">*</span></label>
                                </Col>
                                <Col md={4} className="text-center">
                                <Input
                                name="emailAddress" type="email"
                                onChange={this.handleChange}
                                placeholder="Enter Your Email"
                                onKeyPress={event => {this.onKeyPressRetrisctSomeSC(event)}}
                                maxLength="200" minLength="10" required />
                                </Col>
                                </Row>
                                <br />
                                <Row>
                                <Col md={2}>
                                <label>Organization Name<span className="register_page_marker">*</span></label>
                                </Col>
                                <Col md={4}>
                                <Input  className="capitalize"
                                name="organizationName" type="text"
                                onKeyPress={event => {this.onKeyPressTextOnly(event)}}
                                onChange={this.handleChange}
                                placeholder="Enter Your  Organization Name"
                                minLength="2" maxLength="200" required />
                                </Col>
                                <Col md={2}>
                                <label>City<span className="register_page_marker">*</span></label>
                                </Col>
                                <Col md={4}>
                                <Input  className="capitalize"
                                name="city" type="text"
                                onKeyPress={event => {this.onKeyPressTextOnly(event)}}
                                onChange={this.handleChange}
                                placeholder="Enter Your City Name"
                                minLength="2" maxLength="200" required />
                                </Col>
                                </Row>
                                <br />
                                <Row>
                                <Col md={10} >
                                <label>Requirement<span className="register_page_marker">*</span></label>
                                </Col>
                                </Row>
                                <Row>
                                <Col md={12} className="text-center">
                                <Input placeholder="Enter Your Requirement" name="requirement"
                                maxLength="200"
                                type="textarea" rows="2" onChange={this.handleChange}
                                onKeyPress={event => {this.onKeyPressRetrisctSomeSC(event)}}
                                required />
                                </Col>
                                </Row>

                                <Row>

                                <Col  md={2} >
                                <Button variant="outline-danger" type="submit">Submit</Button>
                                </Col>
                                <Col  md={2} >
                                <Button variant="outline-secondary" type="button" onClick={this.toggle('project')}>Cancel</Button>
                                </Col>
                                </Row>

                                </Form>
                                </Formik>
                                </Modal.Body>
                                </Modal>

                            </div>
                        </Card>
                    </Col>

                    <Col>
                        <Card>
                            <div className='embedded_projectspacing'>
                                <h4 className='aboutus_fontbold'>Trainings</h4>
                                    <p>
                                        <strong>Create a Better version of yourself by being a part of the training and knowledge sharing we offer!
                                        </strong>
                                    </p>
                                <div className='it_buttonalign'>
                                    <Link to='/training' class="cta" style={{ textDecoration: 'none' }}>
                                    <span>Training</span>
                                    <svg width="13px" height="10px" viewBox="0 0 13 10">
                                    <path d="M1,5 L11,5"></path>
                                    <polyline points="8 1 12 5 8 9"></polyline>
                                    </svg>
                                    </Link>
                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>
                <hr/>
            </div>

            <div className='aboutus_mainspace' >
                <h4  data-aos="fade-right">
                    <span className='aboutus_fontbold'>Success </span>
                    <span>Stories </span>
                    <Link to="/success-story">
                    <Plus class="rounded mx-auto homepage_plussize" />
                    </Link>
                </h4>
                <br/>

                <Carousel
                autoPlay={true}
                responsive={responsive}
                infinite={true}
                autoPlaySpeed={2500}>
                    <Row interval={1500} >
                        <div className='it_sscontent' >
                            <br/>
                            <p className='it_ssheading' >
                                Ibbani Food Industries
                                <a href='http://www.ibbanifoods.com/'  target="_blank">
                                    <Plus className=' embedded_plusalign svgcolor' />
                                </a>
                            </p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={IBBANIs} alt='Ibbani Food Industries Website snapshot photo' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    E-commerce website for Ibbani Food industries which manufactures and promotes
                                                    high quality processed masala powders, pickles, papads, herbal powder, honey
                                                    and Malenadu special products.<br/>
                                                </strong>
                                            </p>
                                            <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >Ibbani Food Industries,<br/></span>Kuntavalli,<br/> Thirthahalli</p>
                                        </strong>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >
                                V-Tech Engineers
                                <a href='http://www.vtechengineer.com/'  target="_blank">
                                    <Plus className='embedded_plusalign svgcolor' />
                                </a>
                            </p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={VTECHs} alt='V-tech Engineers Website snapshot photo' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Business website for V-Tech Engineers who invented Areca nut dehusking
                                                    machine, which was the first of its kind in history. Website includes all
                                                    the innovative Agri products from the company.<br/><br/>
                                                    <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >V-Tech Engineers,<br/></span>Kuntavalli,<br/> Thirthahalli</p>
                                                </strong>
                                            </p>
                                        </strong>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >RootsGoods OPC Pvt Ltd
                                <a href='https://www.rootsgoods.com/'  target="_blank">
                                    <Plus className=' embedded_plusalign svgcolor' />
                                </a>
                            </p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={ROOTSGOODSs} alt='RootsGoods Opc Pvt Ltd Website snapshot photo ' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Corporate website for RootsGoods which is an interactive, state of the
                                                    art technology, multi disciplinary platform with proprietary software and
                                                    hardware tools for farmers to maintain, grade, sell and transport their
                                                    commodities from farms to wholesale buyers' address.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >RootsGoods OPC Pvt Ltd,<br/></span> Shivamogga</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >Monica Kulkarni
                                <a href='http://www.monicakulkarni.com/'  target="_blank">
                                    <Plus className=' embedded_plusalign svgcolor' />
                                </a>
                            </p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={MONICAs} alt='Monica Kulkarni Website snapshot photo' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Portfolio website for a professional photographer to showcase portraits
                                                    and stills beautifully captured in her camera!<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >Monica Kulkarni,<br/></span>Bengaluru</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >Government First Grade College
                                <a href='http://gfgckalasa.edu.in/'  target="_blank">
                                    <Plus className=' embedded_plusalign svgcolor' />
                                </a>
                            </p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={GFGCs} alt='Government First Grade College Website snapshot photo' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Educational Institutional website for Government First Grade College, Kalasa, that
                                                    includes all the details about the institution, from facilities to faculties, from
                                                    academic information to Student friendly blog. This also includes courses offered
                                                    and co-curricular activities encouraged by the institution.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >Government First Grade College, <br/></span>Kalasa</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >GLWC-KAR
                                <a href='https://glwc-kar.org/#/index'  target="_blank">
                                    <Plus className=' embedded_plusalign svgcolor' />
                                </a>
                            </p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={GLWCs} alt='Rajya Sarkari Padavi Collegegala Atithi Upanyasakara HitaRakshana Samithi Website snapshot photo' />
                                    </Link>

                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Organization website for Rajya Sarkari Padavi Collegegala Atithi Upanyasakara HitaRakshana Samithi,
                                                    Karnataka, which is a welfare committee of guest lecturers who are currently working across Karnataka
                                                    State Government Degree Colleges. It also includes the online membership for the committee, a step
                                                    closer towards fully digitized organization.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >Rajya Sarkari Padavi Collegegala Atithi Upanyasakara HitaRakshana Samithi (R),<br/></span> Shivamogga</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >V Tech Automotors Ltd
                                <a href='https://www.vaml.in/'  target="_blank">
                                    <Plus className=' embedded_plusalign svgcolor' />
                                </a>
                            </p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={VAMLs} alt='V-tech Automotors Ltd Website snapshot photo' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Landing page website for V-Tech Automotors Ltd, one of the leading EV Manufacturing
                                                    industries with a wide range of electric scooters with affordable and user friendly conditions.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >V Tech Automotors Ltd,<br/></span> Shivamogga</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >RootsGoods OPC Pvt Ltd
                                <a href='https://www.moringa.rootsgoods.com/'  target="_blank">
                                    <Plus className=' embedded_plusalign svgcolor' />
                                </a>
                            </p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={MORINGAs} alt='RootsGoods Opc Pvt Ltd Moringa Website snapshot photo ' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Landing page website for products of Moringa from RootsGoods. Moringa oleifera
                                                    is a plant native to northern India that can also grow in other tropical and
                                                    subtropical places, like Asia and Africa.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >RootsGoods OPC Pvt Ltd,<br/></span> Shivamogga</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >Vishwabhushana Trust
                                <a href='http://www.vishwabhushanatrust.org/'  target="_blank">
                                    <Plus className=' embedded_plusalign svgcolor' />
                                </a>
                            </p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={VISHWAs} alt='Vishwabhushana Trust Website snapshot photo' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Organization website for Vishwabhushana trust is one of the society-oriented
                                                    organizations working for the well-being of the society from Blood donation
                                                    camp to eye-donation driving camp, from Vanamahotsava, to eco-natural trips
                                                    and invited talks for school students in various topics.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >Vishwabhushana Trust,<br/></span>Bhadravathi</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >Sumuka Steels Pvt Ltd
                                <a href='http://www.sumukasteels.com/'  target="_blank">
                                    <Plus className=' embedded_plusalign svgcolor' />
                                </a>
                            </p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={SUMUKHAs} alt='Sumukha Steels Pvt Ltd Website snapshot photo' />
                                    </Link>
                                </Col>


                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Corporate website for the steel industry with modern manufacturing complex
                                                    comprising pattern shop, moulding, melting, fettling, heat treatment, shot
                                                    blasting and other testing facilities required for production of steel and
                                                    alloy steel castings with reliable quality.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >Sumuka Steels Pvt Ltd,<br/></span>Machenahalli</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >Malnad Kitchen
                                <a href='https://www.malnadkitchen.com/'  target="_blank">
                                    <Plus className=' embedded_plusalign svgcolor' />
                                </a>
                            </p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={MALNADs} alt='Malnad Kitchen Website snapshot photo' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    E-commerce and product profile website for homemade food products and catering
                                                    services with a wide range of food categories and having a strong base of satisfied
                                                    customers in Karnataka serving over 20 years of delight taste.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >Malnad Kitchen,<br/></span> Shivamogga</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >Scholar Monks Foundation</p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={SCHOLARs} alt='Scholar Monks Foundation Website snapshot photo' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Organization website for Scholar Monks Foundation which is a Social Welfare
                                                    Startup initiation which facilitates the Scholarship program for the Students
                                                    education institutions of Karnataka.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >Scholar Monks Foundation,<br/></span>Mysore</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >ISVM Conference 2020</p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={ISVMs} alt='ISVM Conference 2020 Website snapshot photo' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Conference website with Online Registration and Abstract submission for 38th ISVM Annual
                                                    Convention and National Symposium 2020 on “Advancement in Veterinary Medicine in Mitigating
                                                    Challenges to Animal Health” organized by Indian Society for Veterinary Medicine at Veterinary
                                                    College, Bangalore.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >ISVM Conference 2020, <br/></span>Bengaluru</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >CSI St. Thomas Church</p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={CSIs} alt='CSI St. Thomas Church Software snapshot photo' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Internal management software for CSI Church, that will keep track of the community members
                                                    and family details along with donations details towards the church.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >CSI St. Thomas Church,<br/></span> Shivamogga</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontentrootsgoods'>
                            <br/>
                            <p className='it_ssheading' >RootsGoods OPC Pvt Ltd</p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link href="/success-story">
                                        <Image src={RGA} alt='RootsGoods Opc Pvt Ltd App snapshot photo ' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Android and iOS mobile application by RootsGoods which is a platform
                                                    for farmers to maintain, sell and transport their commodities from farms
                                                    to wholesale buyers via logistics enabled within the app.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >RootsGoods OPC Pvt Ltd,<br/></span> Shivamogga</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >AMST Conference 2020</p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={AMSTs} alt='AMST Conference 2020 Website snapshot photo' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Conference website with Online Registration and Abstract submission for
                                                    5th Annual Convention of AMST and National Symposium 2020 on “Augmenting
                                                    Sustainable Production, Processing and Safety of Foods of Animal origin
                                                    in Changing Climatic Scenario in India” organized at Veterinary College, Bengaluru.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >AMST Conference 2020,<br/></span>Bengaluru</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >Veterinary College</p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={CLINICALs} alt='Veterinary College Software snapshot photo' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Customized patient record management software for Veterinary Clinical,
                                                    which keeps track of all the patient history while keeping the record
                                                    about the appointments, medication, payment details of all the previous
                                                    pets making the job of the doctor and receptionist much easier with
                                                    customized data export options.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >Veterinary College,<br/></span>Hebbala,<br/> Bengaluru</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >CS Kiran NP and Associates</p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={DSCs} alt='DSC Tracker Software snapshot photo' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    DSC and document tracking software for CA/CS enterprise.
                                                    Helps in easy maintenance of important documents and DSC tokens
                                                    of their clients.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >CS Kiran NP,<br/></span>CS Kiran NP and Associates,<br/> Shivamogga</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >Techno Rings </p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={Technorings} alt='Techno Rings Dashboard snapshot photo' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Data logger and a dashboard to power the products of Industry 4.0. Real
                                                    time foundry data will be sent wirelessly to the software and used for
                                                    further production management and data analytics through the dashboard
                                                    and customized data export options.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >Techno Rings,<br/></span> Shivamogga</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>

                    <Row interval={1500} >
                        <div className='it_sscontent'>
                            <br/>
                            <p className='it_ssheading' >EI-Learn</p>
                            <Row data-aos="fade-up" data-aos-duration="3000">
                                <Col sm={6}>
                                    <Link to="/success-story">
                                        <Image src={EILEARN} alt='EI-Learn Online Learning Portal snapshot photo' />
                                    </Link>
                                </Col>

                                <Col>
                                    <div className='it_sidecontentspace' >
                                        <strong>
                                            <p className='it_sidecontentfontsize' >
                                                <strong>
                                                    <br/>
                                                    Online learning portal for students to access the webinars, sessions or
                                                    classes by their educators, trainers and educational institutions having the
                                                    access to upload their recorded webinars or live sessions to share with the student
                                                    community. This also helps in keeping track of student engagements with the shared video sessions.<br/>
                                                </strong>
                                            </p>
                                        </strong>
                                        <p className='it_ssnamesize aboutus_fontbold' ><span className='it_ssnamecolor' >EI-Learn,<br/></span>Ekathva Innovations</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>
                </Carousel>
            </div>
            <br/>
            {/*Success Modal */}
                  <Modal
                  show={this.state.modal_success} backdrop='static'
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  className="modal_alert">
                  <Modal.Body className="modalBody">
                  <div className="aboutus_textalign">
                  <img src={successImage} width="8%"  alt="ekathvainnovations.com"></img>
                  <br/>
                  <br/>
                  <h4 className="aboutus_textalign"><strong> Success! </strong></h4>
                  <br/>
                  <br/>
                  <h6 className="aboutus_textalign">{this.state.message}</h6>
                  <br/>
                  <Button type="button" variant="outline-danger" onClick={this.toggle('success')}>OK</Button>
                  </div>
                  <br/>
                    </Modal.Body>
                  </Modal>

                  {/*Failure Modal */}
                  <Modal
                  show={this.state.modal_failure} backdrop='static'
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  className="modal_alert">
                  <Modal.Body className="modalBody">
                  <div className="aboutus_textalign">
                  <img src={failureImage} width="8%"  alt="ekathvainnovations.com"></img>
                  <br/>
                  <br/>
                  <h4 className="aboutus_textalign"><strong> Failure! </strong></h4>
                  <br/>
                  <br/>
                  <h6 className="aboutus_textalign">{this.state.message}</h6>
                  <br/>
                  <Button type="button" variant="outline-danger" onClick={this.toggle('failure')}>OK</Button>
                  </div>
                  <br/>
                </Modal.Body>
                  </Modal>


            <Footer/>
        </div>

      )
    }

}
export default ItServicePage;
